import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { toast } from '../utils/toast';
import api from '../utils/api'; // <-- use your axios instance

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/api/users/forgot-password', { email });

      if (res.status === 200) {
        toast.success(t('messages.resetLinkSent'));
      } else {
        toast.error(t('messages.resetLinkFailed'));
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Server error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 bg-white shadow p-6 rounded">
      <h2 className="text-2xl mb-4 text-center">{t('auth.forgotTitle')}</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t('auth.enterEmail')}
          className="border p-2 w-full rounded"
          required
        />
        <button
          type="submit"
          disabled={loading}
          className="bg-green-600 text-white px-4 py-2 rounded w-full"
        >
          {loading ? t('forgot.sending') : t('forgot.sendLink')}
        </button>
      </form>
    </div>
  );
}
